import { defineComponent as _defineComponent } from 'vue'
import { ref, watch, useAttrs, useListeners } from "vue"
import { Client, ClientsSearchQuery } from "@/gql"


export default /*#__PURE__*/_defineComponent({
  __name: 'ClientSelect',
  props: {
  returnObject: { type: Boolean, default: true },
  value: { required: true },
},
  setup(__props) {

const props = __props

const search = ref<string | null>(null)
const selectedId = ref<number | null>(null)



const attrs = useAttrs()
const listeners = useListeners()

watch(
  () => props.value,
  (newValue) => {
    if (newValue) {
      selectedId.value = !props.returnObject ? (newValue as number) : (newValue as Client).id
    }
  },
  { immediate: true }
)

return { __sfc: true,search, selectedId, props, attrs, listeners, ClientsSearchQuery }
}

})